import {getAppUrls} from './Config'

/**
 * The EDU Intelligence page for one survey run.
 *
 * EI addresses a survey by its group cycle id at `/surveys/:groupCycleId`; the old
 * `/EDUDashboard?CycleId=` route no longer exists there and falls through to the EI home page.
 * Without an id (a survey that never ran) the link opens the EI survey list instead of a
 * survey that cannot be found.
 */
function eiSurveyUrl(groupCycleId, host) {
  const surveysUrl = `${getAppUrls(host).EI_URL}/surveys`

  return groupCycleId
    ? `${surveysUrl}/${encodeURIComponent(groupCycleId)}`
    : surveysUrl
}

export {eiSurveyUrl}
